import { StateCreator } from 'zustand';
import { IAppState, ITestSlice } from './stateTypes';

const createTestSlice: StateCreator<IAppState, [], [], ITestSlice> = (set) => ({
    homebaseOptimizationGroup: 'control',
    setHomebaseOptimizationGroup: (group) => set({ homebaseOptimizationGroup: group }),
    optimizedReturnExperience: 'control',
    setOptimizedReturnExperience: (group) => set({ optimizedReturnExperience: group }),
    serveUFTContent: false,
    setServeUFTContent: (serve) => set({ serveUFTContent: serve }),
});

export default createTestSlice;
